export default "__VITE_ASSET__$XkbzrTa__"